module.exports = __webpack_public_path__ + "static/media/zcdt_Symx.8337f42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Symx.png
// module id = 1884
// module chunks = 0 1